/** dummyimage.com — 1920×700, arka plan #f7f7f7, metin rengi #2e2e2e */
const IMG_BASE = 'https://dummyimage.com/1656x710/86A6C9/2e2e2e';

function bannerImage(textParam) {
    const q = textParam ? `&text=${encodeURIComponent(textParam)}` : '';
    return `${IMG_BASE}${q}`;
}

/** @type {Array<{ id: string, imageUrl: string, title: string, description: string, link: string }>} */
export const DUMMY_BANNER_SLIDES = [
    {
        id: '1',
        imageUrl: 'https://istanbulrotary.org/img/db/dsc_9925.jpg',
        title:
            'Tarihçi, yazar ve emekli Tuğgeneral Dr. Naim Babüroğlu konuşmacımızdı',
        description:
            'Cumhuriyet tarihimizin önemli dönüm noktalarını ve askeri stratejileri derinlemesine ele aldığımız bu özel oturumda, Sayın Babüroğlu eşsiz bilgi birikimiyle bizlere ilham verdi.',
        link: '/login',
    },
    {
        id: '2',
        imageUrl: bannerImage('Rotary — Duyuru'),
        title: 'Kulüp toplantısı',
        description:
            'Gündem maddeleri ve konuk konuşmacı hakkında bilgi almak için detay sayfasını ziyaret edin.',
        link: '/panel',
    },
    {
        id: '3',
        imageUrl: bannerImage('Rotary — Haber'),
        title: 'Gençlik programları',
        description:
            'Interact ve Rotaract iş birlikleriyle yürütülen çalışmalar hakkında güncel haberler.',
        link: 'https://example.com',
    },
];
